var map = {
	"./arrow_left.svg": 46801,
	"./arrow_right.svg": 95041,
	"./back.svg": 94377,
	"./bluetooth.svg": 14582,
	"./bluetooth_off.svg": 6747,
	"./cetus.svg": 61386,
	"./checkmark.svg": 79330,
	"./checkmark_dark.svg": 3947,
	"./checkmark_white.svg": 54456,
	"./copy.svg": 9806,
	"./cross.svg": 34578,
	"./cross_red.svg": 30126,
	"./cross_white.svg": 84805,
	"./delete.svg": 89009,
	"./discord.svg": 41621,
	"./down.svg": 60189,
	"./edit.svg": 62170,
	"./eye_off.svg": 33036,
	"./eye_off_black.svg": 66773,
	"./eye_on.svg": 15858,
	"./eye_on_black.svg": 76062,
	"./failsafe.svg": 65957,
	"./favicon.svg": 40506,
	"./fullscreen.svg": 19886,
	"./health.svg": 1867,
	"./heart.svg": 96616,
	"./home.svg": 82764,
	"./home_title.svg": 76551,
	"./infos.svg": 39322,
	"./json.svg": 2680,
	"./lock.svg": 96276,
	"./mail.svg": 25004,
	"./mic.svg": 16051,
	"./minus.svg": 70054,
	"./money.svg": 75611,
	"./move.svg": 76338,
	"./mute.svg": 22859,
	"./notification.svg": 80057,
	"./pause.svg": 52062,
	"./phone.svg": 11001,
	"./play.svg": 26729,
	"./plus.svg": 62073,
	"./print.svg": 51872,
	"./qrcode.svg": 67577,
	"./radio.svg": 21757,
	"./refresh.svg": 32011,
	"./refresh_white.svg": 7285,
	"./remove.svg": 24576,
	"./replay.svg": 97183,
	"./search.svg": 36273,
	"./share.svg": 40227,
	"./show.svg": 44919,
	"./spam.svg": 72999,
	"./stats.svg": 72534,
	"./stop.svg": 26578,
	"./stop_square.svg": 91631,
	"./unlock.svg": 66738,
	"./unmute.svg": 9918,
	"./up.svg": 79171,
	"./user.svg": 91409,
	"./virgo.svg": 45551,
	"./warning.svg": 54203
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28768;